import React, { FC } from 'react';

import { VaultDeposit } from '../VaultDeposit';
import { UserVaultsSection } from '../VaultDeposit/UserVaultsSection';

import { Layout } from '@/shared/ui';

export const Invest: FC = () => {
    return (
        <Layout>
            <UserVaultsSection />
            <VaultDeposit />
        </Layout>
    );
};
